// MineLED Halloween – lekki JS (menu mobilne + efekty)
document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-nav-toggle]');
  if (t) { document.querySelector('[data-mobile-nav]').classList.toggle('is-open'); }

  var thumb = e.target.closest('[data-thumb]');
  if (thumb) {
    var main = document.getElementById('ProductMainImage');
    if (main) { main.src = thumb.getAttribute('data-full'); }
    document.querySelectorAll('[data-thumb]').forEach(function (el) { el.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }

  // licznik ilości − / +
  var step = e.target.closest('[data-qty-minus],[data-qty-plus]');
  if (step) {
    var input = document.getElementById('Quantity');
    if (input) {
      var n = parseInt(input.value, 10); if (isNaN(n)) n = 1;
      n = step.hasAttribute('data-qty-plus') ? n + 1 : Math.max(1, n - 1);
      input.value = n;
    }
  }
});

// ---- Dodawanie do koszyka ----
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
  if (!window.fetch) return; // starsza przeglądarka — zwykłe wysłanie formularza
  e.preventDefault();
  var btn = form.querySelector('[type="submit"]');
  var label = btn ? btn.querySelector('[data-add-label]') : null;
  var prev = label ? label.textContent : null;
  if (btn) { btn.disabled = true; }
  if (label) { label.textContent = 'Dodaję…'; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    body: new FormData(form)
  })
    .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
    .then(function () { window.location.href = '/cart'; })
    .catch(function () {
      if (btn) { btn.disabled = false; }
      if (label && prev) { label.textContent = prev; }
      form.submit(); // ostateczny fallback
    });
});

// ---- Wybór wariantu: przeładuj z ?variant=ID (serwer renderuje właściwą cenę) ----
(function () {
  var root = document.querySelector('[data-product-root]');
  if (!root) return;
  var sel = root.querySelector('[data-variant-select]');
  if (!sel) return;
  var base = (sel.getAttribute('data-product-url') || window.location.pathname).split('?')[0];
  sel.addEventListener('change', function () {
    var id = sel.value;
    if (!id) return;
    window.location.href = base + '?variant=' + encodeURIComponent(id);
  });
})();

(function () {
  var hw = document.getElementById('hw-layer');
  if (!hw) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var spider = '<svg viewBox="0 0 40 44" aria-hidden="true"><g stroke="#0b0810" stroke-width="2" stroke-linecap="round" fill="none"><path d="M14 20 Q6 14 2 18 M14 24 Q5 24 1 30 M15 28 Q7 32 5 40 M16 18 Q10 8 4 8"/><path d="M26 20 Q34 14 38 18 M26 24 Q35 24 39 30 M25 28 Q33 32 35 40 M24 18 Q30 8 36 8"/></g><ellipse cx="20" cy="26" rx="8" ry="10" fill="#0b0810" stroke="#ff7518"/><circle cx="20" cy="14" r="5.5" fill="#0b0810" stroke="#ff7518"/><circle cx="18" cy="13.5" r="1.3" fill="#ff7518"/><circle cx="22" cy="13.5" r="1.3" fill="#ff7518"/></svg>';
  var bat = '<svg viewBox="0 0 64 28" aria-hidden="true"><path fill="#0b0810" stroke="#8e3bd4" stroke-width=".8" d="M32 8c-2 0-3 2-3 4-4-6-10-9-17-8 3 2 4 4 4 7-4-2-9-2-13 0 4 2 7 5 8 9 3-3 7-4 11-3 2 2 5 4 10 4s8-2 10-4c4-1 8 0 11 3 1-4 4-7 8-9-4-2-9-2-13 0 0-3 1-5 4-7-7-1-13 2-17 8 0-2-1-4-3-4z"/><circle cx="30" cy="12" r="1" fill="#ff7518"/><circle cx="34" cy="12" r="1" fill="#ff7518"/></svg>';

  if (hw.dataset.spiders === 'true') {
    [['7%','140px','7s','-1s',''],['46%','90px','9s','-4s','hw-desk'],['88%','200px','8s','-2.5s','']]
    .forEach(function (c) { var s=document.createElement('div'); s.className='hw-spider '+c[4];
      s.style.cssText='left:'+c[0]+';--drop:'+c[1]+';animation-duration:'+c[2]+';animation-delay:'+c[3];
      s.innerHTML=spider; hw.appendChild(s); });
  }
  if (hw.dataset.bats === 'true') {
    [['14%','54px','16s','-2s',''],['32%','40px','21s','-9s','hw-desk'],['58%','34px','19s','-14s',''],['8%','30px','25s','-5s','hw-desk']]
    .forEach(function (c) { var b=document.createElement('div'); b.className='hw-bat '+c[4];
      b.style.cssText='top:'+c[0]+';width:'+c[1]+';animation-duration:'+c[2]+';animation-delay:'+c[3];
      b.innerHTML=bat; hw.appendChild(b); });
  }
  if (hw.dataset.falling === 'true' && !reduce) {
    var it=['🎃','🍂','🍁','🎃','👻','🍂','🦇','🍬'], n=window.innerWidth<750?7:14;
    for (var i=0;i<n;i++){ var e=document.createElement('span'); e.className='hw-fall'; e.textContent=it[i%it.length];
      e.style.left=Math.random()*100+'vw'; e.style.fontSize=14+Math.random()*18+'px';
      e.style.animationDuration=11+Math.random()*12+'s'; e.style.animationDelay=-Math.random()*20+'s';
      e.style.setProperty('--sway',Math.random()*160-80+'px'); e.style.setProperty('--spin',Math.random()*540-270+'deg');
      e.style.opacity=(.45+Math.random()*.45).toFixed(2); hw.appendChild(e); }
  }

  document.querySelectorAll('canvas[data-art]').forEach(function (c) {
    var A = window.__HW_ART && window.__HW_ART[c.dataset.art]; if (!A) return;
    var x=c.getContext('2d');
    A.m.forEach(function (row,y){ for (var i=0;i<row.length;i++){ var ch=row[i]; if (A.p[ch]){ x.fillStyle=A.p[ch]; x.fillRect(i,y,1,1);} } });
    c.setAttribute('role','img');
  });

  var sk=document.getElementById('hero-skyline');
  if (sk){ for (var j=0;j<22;j++){ var bl=document.createElement('i'); bl.style.height=(18+Math.round(Math.random()*4)*12)+'%'; sk.appendChild(bl); } }
})();


// ---- Losowe produkty "Zobacz inne lampki" ----
(function () {
  var grid = document.querySelector('[data-related-grid]');
  if (!grid) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-related-card]'));
  var show = parseInt(grid.getAttribute('data-show'), 10) || 4;
  // tasowanie Fisher–Yates
  for (var i = cards.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = cards[i]; cards[i] = cards[j]; cards[j] = tmp;
  }
  cards.forEach(function (c, idx) {
    if (idx < show) { grid.appendChild(c); c.style.display = ''; }
    else { c.style.display = 'none'; }
  });
})();


// ---- Koszyk: automatyczna aktualizacja (bez przycisku "Zaktualizuj") ----
(function () {
  var root = document.querySelector('[data-cart-root]');
  if (!root) return;

  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    try { return v.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł'; }
    catch (e) { return v.toFixed(2).replace('.', ',') + ' zł'; }
  }

  function setBusy(b) { root.style.opacity = b ? '.6' : ''; root.style.pointerEvents = b ? 'none' : ''; }

  function change(key, qty) {
    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (qty === 0 || cart.item_count === 0) { window.location.reload(); return; }
        // zaktualizuj sumę
        var total = root.querySelector('[data-cart-total]');
        if (total) total.textContent = money(cart.total_price);
        // zaktualizuj cenę tej pozycji
        var row = root.querySelector('[data-cart-row][data-key="' + key + '"]');
        var line = cart.items.filter(function (it) { return it.key === key; })[0];
        if (row && line) {
          var lp = row.querySelector('[data-cart-line-price]');
          if (lp) lp.textContent = money(line.final_line_price);
          var qi = row.querySelector('[data-cart-qty]');
          if (qi) qi.value = line.quantity;
        }
        setBusy(false);
      })
      .catch(function () { window.location.reload(); });
  }

  root.addEventListener('click', function (e) {
    var row = e.target.closest('[data-cart-row]');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var input = row.querySelector('[data-cart-qty]');
    if (e.target.closest('[data-cart-remove]')) { change(key, 0); return; }
    if (e.target.closest('[data-cart-plus]')) {
      var n = (parseInt(input.value, 10) || 0) + 1; input.value = n; change(key, n); return;
    }
    if (e.target.closest('[data-cart-minus]')) {
      var m = Math.max(0, (parseInt(input.value, 10) || 0) - 1); input.value = m; change(key, m); return;
    }
  });

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var row = input.closest('[data-cart-row]');
    var key = row.getAttribute('data-key');
    var n = Math.max(0, parseInt(input.value, 10) || 0);
    change(key, n);
  });
})();
